import React, { useEffect } from "react";

const ReturnRefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8 bg-white">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          RETURN & REFUND POLICY
        </h1>
        <p className="text-gray-600">Updated at July 19th, 2025</p>
      </header>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Definitions and key terms
        </h2>
        <p className="mb-4 text-gray-700">
          To help explain things as clearly as possible in this Return & Refund
          Policy, every time any of these terms are referenced, are strictly
          defined as:
        </p>
        <ul className="list-disc ml-6 space-y-2 text-gray-700">
          <li>
            <strong>Company:</strong> when this policy mentions “Company,”
            “we,” “us,” or “our,” it refers to Sairah A venture of Soradis Group
            under Soradis Jewellers Private Limited, that is responsible for
            your information under this Return & Refund Policy.
          </li>
          <li>
            <strong>Customer:</strong> refers to the company, organization or
            person that signs up to use the Sairah A venture of Soradis Group
            under Soradis Jewellers Private Limited Service to manage the
            relationships with your consumers or service users.
          </li>
          <li>
            <strong>Device:</strong> any internet connected device such as a
            phone, tablet, computer or any other device that can be used to
            visit Sairah A venture of Soradis Group under Soradis Jewellers
            Private Limited and use the services.
          </li>
          <li>
            <strong>Service:</strong> refers to the service provided by Sairah A
            venture of Soradis Group under Soradis Jewellers Private Limited as
            described in the relative terms (if available) and on this platform.
          </li>
          <li>
            <strong>Website:</strong>{" "}
            <a
              href="https://www.sairahjewels.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              https://www.sairahjewels.com
            </a>
          </li>
          <li>
            <strong>You:</strong> a person or entity that is registered with
            Sairah A venture of Soradis Group under Soradis Jewellers Private
            Limited to use the Services.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Return & Refund Policy
        </h2>
        <p className="mb-4 text-gray-700">
          Thanks for shopping at Sairah A venture of Soradis Group under
          Soradis Jewellers Private Limited. We appreciate the fact that you
          like to buy the stuff we build. We also want to make sure you have a
          rewarding experience while you’re exploring, evaluating, and
          purchasing our products.
        </p>
        <p className="mb-4 text-gray-700">
          As with any shopping experience, there are terms and conditions that
          apply to transactions at Sairah A venture of Soradis Group under
          Soradis Jewellers Private Limited. We’ll be as brief as our attorneys
          will allow. The main thing to remember is that by placing an order or
          making a purchase at Sairah A venture of Soradis Group under Soradis
          Jewellers Private Limited, you agree to the terms set forth below
          along with Sairah A venture of Soradis Group under Soradis Jewellers
          Private Limited’s Privacy Policy.
        </p>
        <p className="mb-4 text-gray-700">
          If there’s something wrong with the item you bought, or if you are not
          happy with it, you shall have a timing of <strong>15 minutes</strong>{" "}
          to cancel the order from the time you confirm & place your order. This
          cancellation button is visible in order history section of your SAIRAH
          account for 15 minutes. Once the cancellation button expires after 15
          minutes, you will not be able to cancel your order.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Refunds</h2>
        <p className="mb-4 text-gray-700">
          We at Sairah A venture of Soradis Group under Soradis Jewellers
          Private Limited commit ourselves to serving our customers with the
          best products. Every single product that you choose is thoroughly
          inspected, checked for defects and packaged with utmost care. We do
          this to ensure that you fall in love with our products.
        </p>
        <p className="mb-4 text-gray-700">
          Sadly, there are times when we may not have the product(s) that you
          choose in stock, or may face some issues with our inventory and
          quality check. In such cases, we may have to cancel your order. You
          will be intimated about it in advance so that you don't have to worry
          unnecessarily about your order. If you have purchased via Online
          payment (not Cash on Delivery), then you will be refunded once our
          team confirms your request.
        </p>
        <p className="mb-4 text-gray-700">
          We carry out thorough quality check before processing the ordered
          item. We take utmost care while packing the product. At the same time
          we ensure that the packing is good such that the items won’t get
          damaged during transit. Please note that Sairah A venture of Soradis
          Group under Soradis Jewellers Private Limited is not liable for
          damages that are caused to the items during transit or transportation.
        </p>
        <p className="mb-4 text-gray-700">
          We follow certain policies to ensure transparency, efficiency and
          quality customer care:
        </p>
        <ul className="list-disc ml-6 space-y-2 text-gray-700">
          <li>
            We allow returns on sold products. But only under one condition and
            that is when there is an issue with the plating of the jewellery. We
            have a 90 days warranty policy under which we ensure that the
            plating of our jewelleries are taken care of. Our warranty covers
            only and specifically the plating of the jewelleries. No other
            issues or concerns are addressed under our warranty policy.
          </li>
          <li>
            When the product is delivered to the customer, there is a ticket
            window of 90 days to raise warranty claim on the product. Under
            orders section, there is a button named “Claim Warranty”, this
            button shall be clickable from the day the product is marked as
            delivered and the button expires immediately once the 90 days ticket
            window expires.
          </li>
          <li>
            When a customer raises warranty claim and returns the product, our
            quality control team closely analyzes the jewellery and investigates
            the case. If the jewellery plating is found to be tarnished or
            corroded, we take complete responsibility and correct the jewellery
            piece and send it back to the customer. In case of successful
            warranty claim, we bear the shipping charges of sending the product
            to customer’s address from our manufacturing unit. Shipping charge
            of collecting the jewellery from customer’s address and transporting
            to our factory is completely borne by us.
          </li>
          <li>
            When the returned piece of jewellery reaches our quality control
            team, and upon further investigation it is found that the plating
            was effected because of careless handling by the customer by
            bringing the jewellery in contact of soap, handwash, shower gel or
            other chemicals, no repairing or correction of jewellery is any
            further done by us. We send back the jewellery to the customer
            absolutely at their expense of two way shipping. The shipping amount
            shall be communicated to the customer by our support team. Once the
            customer mails the proof of payment of shipping amount to{" "}
            <a
              href="mailto:support@sairahjewels.com"
              className="text-blue-600 underline"
            >
              support@sairahjewels.com
            </a>
            , we shall dispatch the jewellery to the customer’s address
            registered under his Sairah account. In cases where customer denies
            to pay the two ways shipping expense which is incurred or to be
            incurred, the jewellery shall be held back at our manufacturing unit
            and we take no legal responsibility or liability for same.
          </li>
          <li>
            For every product, warranty can be claimed only once if the warranty
            claim is accepted by our team.
          </li>
          <li>
            We may or may not engage in reselling used products because this
            decision is completely taken by our quality control team from case
            to case basis. But in all circumstances, we ensure that the customer
            is delivered the best quality product.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          For International Orders
        </h2>
        <p className="mb-4 text-gray-700">
          We follow certain policies to ensure transparency, efficiency and
          quality customer care:
        </p>
        <ul className="list-disc ml-6 space-y-2 text-gray-700">
          <li>
            We allow returns on sold products. But only under one condition and
            that is when there is an issue with the plating of the jewellery. We
            have a 90 days warranty policy under which we ensure that the
            plating of our jewelleries are taken care of. Our warranty covers
            only and specifically the plating of the jewelleries. No other
            issues or concerns are addressed under our warranty policy.
          </li>
          <li>
            When the product is delivered to the customer, there is a ticket
            window of 90 days to raise warranty claim on the product. Under
            orders section, there is a button named “Claim Warranty”, this
            button shall be clickable from the day the product is marked as
            delivered and the button expires immediately once the 90 days ticket
            window expires.
          </li>
          <li>
            When a customer raises warranty claim and returns the product, our
            quality control team closely analyzes the jewellery and investigates
            the case. If the jewellery plating is found to be tarnished or
            corroded, we take complete responsibility and correct the jewellery
            piece and send it back to the customer. In case of successful
            warranty claim, we bear the shipping charges of sending the product
            to customer’s address from our manufacturing unit. Shipping charge
            of collecting the jewellery from customer’s address and transporting
            to our factory is completely borne by us.
          </li>
          <li>
            When the returned piece of jewellery reaches our quality control
            team, and upon further investigation it is found that the plating
            was effected because of careless handling by the customer by
            bringing the jewellery in contact of soap, handwash, shower gel or
            other chemicals, no repairing or correction of jewellery is any
            further done by us. We send back the jewellery to the customer
            absolutely at their expense of two way shipping. The shipping amount
            shall be communicated to the customer by our support team. Once the
            customer mails the proof of payment of shipping amount to{" "}
            <a
              href="mailto:support@sairahjewels.com"
              className="text-blue-600 underline"
            >
              support@sairahjewels.com
            </a>
            , we shall dispatch the jewellery to the customer’s address
            registered under his Sairah account. In cases where customer denies
            to pay the two ways shipping expense which is incurred or to be
            incurred, the jewellery shall be held back at our manufacturing unit
            and we take no legal responsibility or liability for same.
          </li>
          <li>
            For every product, warranty can be claimed only once if the warranty
            claim is accepted by our team.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Your Consent
        </h2>
        <p className="mb-4 text-gray-700">
          By using our website, registering an account, or making a purchase,
          you hereby consent to our Return & Refund Policy and agree to its
          terms.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Changes To Our Return & Refund Policy
        </h2>
        <p className="mb-4 text-gray-700">
          Should we update, amend or make any changes to this document so that
          they accurately reflect our Service and policies. Unless otherwise
          required by law, those changes will be prominently posted here. Then,
          if you continue to use the Service, you will be bound by the updated
          Return & Refund Policy. If you do not want to agree to this or any
          updated Return & Refund Policy, you can delete your account.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Contact Us
        </h2>
        <p className="text-gray-700">
          If, for any reason, You are not completely satisfied with any good or
          service that we provide, don't hesitate to contact us and we will
          discuss any of the issues you are going through with our product.
          <br />• Email:{" "}
          <a
            href="mailto:support@sairahjewels.com"
            className="text-blue-600 underline"
          >
            support@sairahjewels.com
          </a>
          <br />• Phone:{" "}
          <a href="tel:+918828826996" className="text-blue-600 underline">
            +91 88288 26996
          </a>
        </p>
      </section>
    </div>
  );
};

export default ReturnRefundPolicy;
